import { Match, Period } from '../types';
import {
  hideInfoBox,
  updateMatchBetCourses,
  updateMatchBetStatistics,
  updateMatchPeriodName,
  updateMatchScore,
  updateMatchSets,
  updateWinnerLogoName,
  updateWinnerStyle,
  updateTopEventMetaStatus,
  updateMatchScoreDetailsPeriods,
  updateMatchResultOfCategoryOthers,
} from '../utils/index';

interface TipsportBetCourses {
  home_win: string;
  away_win: string;
  draw_course: string;
  draw: string;
}

interface TipsportBetStatistics {
  bets_percentage: {
    home_win: string;
    away_win: string;
    draw_course: string;
    draw: string;
  };
}

interface XmlData {
  status: string;
  periods: Period[];
}

export const detailMatchPageController = (
  matchElement: HTMLElement,
  matchData: Match,
  xmlData: XmlData,
  tipsportCourses?: TipsportBetCourses | TipsportBetStatistics
) => {
  if (!matchElement) {
    console.warn(`Element s [data-match-id="${matchData.id}"] nebyl nalezen.`);
    return;
  }

  const matchStatus = matchData.xml_status.toLowerCase();
  const matchSport = matchElement.getAttribute('data-match-sport');
  const isLiveMatch = matchStatus === 'live';
  const isFinMatch = matchStatus === 'fin';

  if (isLiveMatch) {
    hideInfoBox('data-sportmod-comments-start-match-info-box');
    hideInfoBox('data-sportmod-comments-update-match-info-box');
  }

  updateMatchScore({
    matchElement,
    matchData,
    matchStatus,
    typographyClass: 'h1',
  });

  updateMatchBetCourses(matchElement, matchStatus, tipsportCourses as TipsportBetCourses);
  updateMatchBetStatistics(matchElement, matchStatus, tipsportCourses as TipsportBetStatistics);
  updateTopEventMetaStatus(matchElement, matchStatus);
  updateMatchPeriodName(matchElement, xmlData.status);
  updateMatchResultOfCategoryOthers({ matchElement, result: matchData?.result_string });

  if (matchSport !== 'ten') {
    updateMatchScoreDetailsPeriods(matchElement, xmlData.periods);
  }

  if (isFinMatch && matchSport !== 'ten') {
    updateWinnerLogoName({ matchElement, score1: matchData.score1, score2: matchData.score2 });
  }

  if ((isLiveMatch || isFinMatch) && xmlData.periods && matchSport === 'ten') {
    updateMatchSets(matchElement, xmlData.periods, matchStatus);

    if (isFinMatch) {
      updateWinnerStyle({
        matchElement,
        score1: matchData.score1,
        score2: matchData.score2,
        matchOverviewType: 'detailPage',
      });
    }
  }
};
